import React from 'react';

const ProviderNav = ({onNavClick, selectedSection }) => {

    const navButton = (id, label, condition = true) =>
        condition && (
            <span
                className={`nav-button ${selectedSection === id ? 'active' : ''}`}
                onClick={() => onNavClick(id)}
            >
                {label}
            </span>
        );

    return (
        <div className="nav-buttons-container">
            <div className="nav-buttons d-md-block buttons-wrapper">
                {navButton('eligibility-verification-container', 'Eligibility Verification')}
                {navButton('claim-status-container', 'Claim Status Lookup')}
                {/*{navButton('provider-contact-container', 'Contact')}*/}
                {navButton('faq-container', 'FAQ') }
            </div>
        </div>
    );
};

export default ProviderNav;
